'use client';

import type { RenderElementProps } from 'slate-react';

import type { LinkElement } from '../types/SlateNodes';

/**
 * Slate render component for inline `link` elements *inside the
 * editor*. Mirrors the rendered chip from SlateMessageRenderer but
 * forwards `attributes` and renders `children` (which Slate uses
 * to drive selection / cursor positioning inside the link).
 *
 * `onClick` is intentionally absent — while the user is editing,
 * clicking a link should place the cursor, not navigate. The
 * rendered-message side (SlateMessageRenderer) has the
 * navigation handler.
 */
export function SlateEditorLink({
  attributes,
  children,
  element,
}: RenderElementProps) {
  // Cast through `unknown` because Slate's Element type is
  // augmented elsewhere in the workspace to a union that doesn't
  // include `link`. Runtime guarantee: this renderer is only
  // invoked when `element.type === 'link'`.
  const link = element as unknown as LinkElement;
  return (
    <a {...attributes} href={link.url} className="text-brand-text underline">
      {children}
    </a>
  );
}
